import { ErrorWithCause } from "@common/error-with-cause";

export class JsonSchemaValidatorError extends ErrorWithCause {
  constructor(message: string, cause?: Error) {
    super(message, cause);
  }
}
